import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { AgentIcon, SkillsIcon } from '@/const'
import { IconV2ClockOutline } from '@icons/IconV2ClockOutline'

const navigation = () => [
  { title: 'Agents', Icon: AgentIcon, path: 'agents', visible: true },
  { title: 'Skills', Icon: SkillsIcon, path: 'skills', visible: true },
  { title: 'Schedules', Icon: IconV2ClockOutline, path: 'schedules', visible: true },
]

export function AgentStudioNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  return <FlatSidebarMenu items={navigation()} sidebarOpen={sidebarOpen} />
}
